<template>
    <div class="container-fluid" v-if="school && department && program">
        <div class="row justify-content-between">
            <div class="col">
                <h3>Хичээлүүд /{{department.name}}{{program.name}}</h3>
                <h6>Xичээлийн тоо: {{classLessons.length}}</h6>
            </div>
        </div>
        <div class="container-fluid p-0">
            <div class="container">
                <div class="card bordered-card my-4">
                    <div class="card-header py-3">
                        <div class="row">
                            <div class="col">
                                <h6 class="m-0 font-weight-bold text-primary">Хичээлийн жагсаалт</h6>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive" v-if="classLessons!=null && classLessons.length>0">
                        <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                            <thead>
                            <tr>
                                <th>№</th>
                                <th>Нэр</th>
                                <th>Багш</th>
                                <th>Төрөл</th>
                                <th>Ангиар/Группээр</th>
                                <th>Үзүүлэлт</th>
                                <th>Үйлдэл</th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(teacher, index) in classLessons" v-bind:key="teacher.id">
                                    <td>{{index+1}}</td>
                                    <td>
                                        {{teacher.name}} 
                                        <small v-if="isXAdmin(userProfile)" class="text-primary">{{teacher.id}}</small>
                                    </td>
                                    <td>
                                        <span v-if="teacher.teachers">
                                            {{teacher.teachers[0].firstName}}
                                        </span>
                                    </td>
                                    <td>
                                        <div  class="row">
                                            <div class="col" v-if="teacher.procent">
                                                <div class="progress">
                                                    <div class="progress-bar bg-info" role="progressbar" v-bind:style="'width: '+teacher.procent+'%'" aria-valuemin="0" aria-valuemax="100">{{teacher.procent}} %</div>
                                                </div>
                                            </div>
                                            <div class="col" v-else>
                                                <div class="progress">
                                                    <div class="progress-bar bg-danger" role="progressbar" v-bind:style="'width: '+0+'%'" aria-valuemin="0" aria-valuemax="100">0 %</div>
                                                </div>
                                            </div>
                                        </div>

                                    </td>
                                    <td>
                                        <span class="badge badge-success" v-if="teacher.categoryTypeId=='zaaval'">{{teacher.categoryTypeName}}</span>
                                        <span class="badge badge-warning" v-else>{{teacher.categoryTypeName}}</span>
                                            
                                        </td>
                                        <td>
                                            <span v-if="teacher.isGroup" class="badge badge-danger">группээр</span>
                                            <span v-else class="badge badge-primary">ангиар</span>     
                                        </td>
                                    <td>
                                        <!-- <button class="btn btn-sm btn-primary" @click="goLessonDetail(teacher)">харах</button> -->
                                    </td>
                                </tr>
                            
                            </tbody>
                        </table>
                            <!-- <div v-if="!searched">
                                <button v-if="loading==false" @click="getTeacherData()" class="nextbutton shadow" style=""><i class="fas fa-arrow-down fa-2x" style="color:black!important;height:40; width:40"></i></button>
                                <button v-else type="button" class="btn btn-success btn-block" disabled>
                                    <span class="spinner-border spinner-border-sm"></span>
                                    Loading..
                                </button>
                            </div> -->
                        </div>
                        <div v-else class="alert alert-info text-center">Одоогоор мэдээлэл ороогүй байна.</div>

                    </div>
                </div>
            </div>
          
        </div>
        <div v-if="loading==true" style="position:fixed;z-index:10000000; top:45%;left:45%">
            <div class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-secondary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-success" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-danger" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-warning" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-info" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-dark" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
     

    </div>
    
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
const fb = require('../../../firebaseConfig.js');
import timetable from '../shared/timetable.js';
import myfunction from '../../global/myfunction.js';
    export default {
        data() {
            return {
               tab_selected:0,
               classLessons:[],
               lastVisible:null,
               loading:false,
               last:false,
               showSimple:true,
               searchValue:null,
               searched:false,
               searchField:'email',
               pageSize:20,
               school:null,
               department:null,
               program:null,
               schedules:[],
               lines:[1, 2],
            }
        },
        mixins:[timetable,myfunction],
        props: {
            schoolId: { 
                required: true,
            },
            departmentId:{
                required:true
            },
            programId:{
                required:true
            },
            
        },
        computed: {
            ...mapState(['userProfile', 'currentUser'])
        },
        watch: {
           
        },
        methods: {
    
            _sortedArray: function() {
                function compare(a, b) {
                    if (a.name < b.name)
                    return -1;
                    if (a.name > b.name)
                    return 1;
                    return 0;
                }
                return this.classLessons.sort(compare);
            },
         
            async _findCategory(schoolId,lesson){
                var catRef = fb.db.collection("schools/"+schoolId+"/categories").doc(lesson.category.id);
                await catRef.get().then(function(doc) {
                    lesson.categoryTypeId = doc.data().typeDetail.id;
                    lesson.categoryTypeName = doc.data().typeDetail.name;
                }).catch(function(error) {
                    console.log("Error getting cached document:", error);
                });
            },
       
            async _getData(){

                this.loading = true;

                this._getTimeTables();
                var schoolDoc=await fb.db.doc('schools/'+this.schoolId).get();
                if(schoolDoc.exists){
                    let school=schoolDoc.data();
                    school.id=schoolDoc.id;
                    school.ref=schoolDoc.ref;
                    this.school=school
                    this.teacheclassLessonsrs=[];

                    var departmentDoc=await schoolDoc.ref.collection("departments").doc(this.departmentId).get();
                    if(departmentDoc.exists){
                        let department=departmentDoc.data();
                        department.id=departmentDoc.id;
                        department.ref=departmentDoc.ref;
                        this.department=department

                        var programDoc=await departmentDoc.ref.collection("programs").doc(this.programId).get();
                        if(programDoc.exists){
                            let program=programDoc.data();
                            program.id=programDoc.id;
                            program.ref=programDoc.ref;
                            this.program=program;
                        }

                    }
                    await this.getTeacherData();
                    this.loading = false;
                }
            },
            async getLessonCategories(){
                var query =fb.db.collection("schools/"+this.schoolId+"/categories").orderBy("index", "asc");
                if(query!=null){
                    var documentSnapshots=await query.get();
                    this.lastVisible= documentSnapshots.docs[documentSnapshots.docs.length-1];
                    documentSnapshots.forEach(doc=> {
                        let object=doc.data()
                        object.id = doc.id
                        this.lessonList.push(object);
                    });
                    if(documentSnapshots.size!=25)
                        this.last=true;
                }
            },
        
            async getTeacherData(){
                
                var query=fb.db.collection("schools/"+this.schoolId+"/lessons")
                    .where("programs", "array-contains", 
                        fb.db.doc("/schools/"+this.schoolId+"/departments/"+this.departmentId+"/programs/"+this.programId)
                    );
                
                if(query!=null){
                    var lessonsDatas=await query.get();
                    for(const doc of lessonsDatas.docs){

                        let lesson=doc.data()
                        lesson.id = doc.id;
                        lesson.procent=0;
                        lesson.ref = doc.ref;
                        lesson.scored = false;
                        if(lesson.category && lesson.category.id){
                            await this._findCategory(this.schoolId,lesson);
                        }
                        
                        if(lesson && lesson.numberOfUnderstand && lesson.numberOfTotalStatus){
                            lesson.procent=(lesson.numberOfUnderstand*100/lesson.numberOfTotalStatus).toFixed(2)
                        }
                        if(!(lesson.deleted!=null&&lesson.deleted!=undefined&&lesson.deleted==true)){
                            this.classLessons.push(lesson);
                        }
                        
                    };
                
                }
                await this._sortedArray(this.classLessons);
            },

         
            goLessonDetail(lesson){
                if(this.userProfile && this.userProfile.role=="teacher")
                    this.$router.push({ name: 'LessonDetailPublic', params: { lessonId: lesson.id, schoolId: this.schoolId, sts: true} });
                else
                    this.$router.push({ name:'SLessonDetail', params:{ schoolId: schoolId, lessonId: teacher.id } });
            },
       
  
        },
        created() {

            this.classLessons=[];
            this._getData();
                
        },

        filters: {
            formatDate(val) {
                if (!val) { return '-' }
                let date = val.toDate()
                return moment(date).fromNow()
            },
            trimLength(val) {
                if (val.length < 200) { return val }
                return `${val.substring(0, 200)}...`
            }
        }
    }
</script>
